import { buildService } from './decorated-service';
import config from '../../../config';
import { navigateToExternal } from '../../../core/util';
import settings from '../../../settings.json';

const api = buildService('/nasu-svc/service/customer');
const baseAPI = buildService('/nasu-svc/service');

export const mockedRPSCustomerData = {
  firstName: 'TESTFOURF',
  middleName: '',
  lastName: 'TESTFOURL',
  primaryEmailAddress: 'test.user@test.com',
  taxID: '916927501',
  customerType: 'RPS',
  citizenshipType: null,
  dateOfBirth: '1974-07-22T04:00:00.000+0000',
  dateOfBirthString: '01/01/1985',
  phoneNumbers: [],
  primaryAddress: {
    street1: '4515 PAINTERS MILL ROAD',
    state: 'MD',
    country: null,
    zip: '21117',
    zip4: '',
    city: 'Owings Mills',
    addressType: 'primary',
    usaddress: true
  },
  addresses: [
    {
      street1: '4515 PAINTERS MILL ROAD',
      state: 'MD',
      country: null,
      zip: '21117',
      city: 'Owings Mills',
      addressType: 'primary'
    }
  ],
  username: null,
  omniStatus: '00',
  omniStatusDesc: 'ACTIVE/ELIGIBLE',
  terminated: true
};

export const mockedCustomerData = {
  firstName: 'TESTFOURF',
  middleName: '',
  lastName: 'TESTFOURL',
  primaryEmailAddress: 'test.user@test.com',
  taxID: '916927501',
  customerType: 'RPS',
  citizenshipType: null,
  dateOfBirth: '1974-07-22T04:00:00.000+0000',
  dateOfBirthString: '01/01/1985',
  phoneNumbers: [
    {
      areaCode: '800',
      exchange: '225',
      localNumber: '5132',
      phoneNumberType: 'cellular'
    }
  ],
  primaryAddress: {
    street1: '4515 PAINTERS MILL ROAD',
    state: 'MD',
    country: null,
    zip: '21117',
    zip4: '',
    city: 'Owings Mills',
    addressType: 'primary',
    usaddress: true
  },
  addresses: [
    {
      street1: '4515 Painters Mill Road',
      street2: 'A',
      street3: '',
      state: 'NY',
      country: 'US',
      zip: '10001',
      zip4: '0000',
      city: 'New York',
      addressType: 'primary',
      usaddress: true,
      foreignAddress: false,
      militaryAddress: false
    },
    {
      street1: '4515 PAINTERS MILL ROAD',
      street2: '',
      street3: '',
      state: 'MD',
      country: 'US',
      zip: '21117',
      zip4: '4903',
      city: 'Owings Mills',
      addressType: 'secondary',
      usaddress: true,
      foreignAddress: false,
      militaryAddress: false
    },
    {
      street1: '4515 PAINTERS MILL ROAD',
      street2: '',
      street3: '',
      state: 'NY',
      country: 'US',
      zip: '10001',
      zip4: '4404',
      city: 'New York',
      addressType: 'secondary',
      usaddress: true,
      foreignAddress: false,
      militaryAddress: false
    }
  ],
  username: null,
  omniStatus: '00',
  omniStatusDesc: 'ACTIVE/ELIGIBLE',
  terminated: true
};

// customer error codes that need specific error handling
const errorCodes = [204, 401, 403, 404, 500];
// handle variations of customer status codes
// default - returns response status
// 401 - recall token ONCE; in the case orchis-token not included for first customer call
// 403 - should direct a user to the enablement page and redirect back to flow
export const handleServiceResponse = (resp: any): Promise<any> | void => {
  if (resp?.status === 403) {
    const returnUrl = window.location.href;
    const enablementUrl = `${config(
      'returnUrlPrefix'
    )}usis/login/enablement?pdurl=/clx-tk/token-exchange/redirect/nasu?sdurl=${returnUrl}`;
    return navigateToExternal(enablementUrl);
  }
  return resp.status;
};

export const getCustomerData = async (): Promise<any> => {
  if (settings['mockedMode']) return mockedCustomerData;
  return api.http.get('', { handleServiceResponse, errorCodes });
};

export const convertProspectCustomer = async (): Promise<any> => {
  return api.http.get('/convert-prospect', {
    handleServiceResponse,
    errorCodes
  });
};

export const convertFONASUProspectCustomer = async (
  uberId: string
): Promise<any> => {
  return api.http.post(
    '/front-office/convert-prospect',
    { uberId },
    { handleServiceResponse, errorCodes }
  );
};

export const getCustomerDataById = async (businessPartyId): Promise<any> => {
  if (settings['mockedMode']) return mockedCustomerData;
  const payload = businessPartyId && { businessPartyId };

  return api.http.post('', payload, { errorCodes, ignoreServiceFailure: true });
};

export const getOCRCustomerDataById = async (ssn, planNumber): Promise<any> => {
  if (settings['mockedMode']) return mockedRPSCustomerData;
  const payload = { ssn, planNumber };

  return baseAPI.http.post('/ocr-customer', payload, {
    errorCodes,
    ignoreServiceFailure: true
  });
};

export default api;
